<template>
  <TabbedBox>
    <template v-slot:tablist>
      <Tab :first="true" tabid="tab-1">
        <i class="far fa-dolly-flatbed"></i> Purchase Orders
      </Tab>
    </template>
    <template v-slot:tabcontent>
      <TabPage :first="true" tabid="tab-1">

        <PurchaseOrderDataTable :useQueryData="true">
          <template v-slot:title>
            <h3>Purchase Order List</h3>
          </template>
          <template v-slot:tools>
            <LinkButton type="new" href="/purchasing/purchaseorders/new" v-if="userHasCreatePermission(PermissionTypes.PurchasingPermissionTypes.purchaseOrderBulk) || userHasCreatePermission(PermissionTypes.PurchasingPermissionTypes.purchaseOrderStandard)" sizeClass="btn"> New Purchase Order</LinkButton>
          </template>
        </PurchaseOrderDataTable>

      </TabPage>
    </template>
  </TabbedBox>
</template>

<script>
import TabbedBox from "@/components/layout/tabbedBox.vue"
import Tab from "@/components/layout/tab.vue"
import TabPage from "@/components/layout/tabPage.vue"
import PurchaseOrderDataTable from '@/modules/purchasing/components/purchaseOrderDataTable'

export default {
  name: "PurchaseOrderList",
  components: {
    TabbedBox,
    Tab,
    TabPage,
    PurchaseOrderDataTable
  },
  props: {
    filterType: String
  },
  computed: {
    title() {
      return this.$route.meta.title
    }
  }
};
</script>
